<template>
  <div class="app-page" :style="customStyle">
    <generic-html :component="htmlComponent" />
  </div>
</template>

<script>
import _ from 'lodash'
import {mapActions} from 'vuex'
import GenericHtml from '@/components/generic/GenericHtml'

export default {
  components: {
    GenericHtml,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      htmlComponent: {}
    }
  },
  computed: {
    pageId() {
      return _.get(this.data, 'pageId', '') ||
        _.get(this.data, 'appPageId', '')
    },
    customTagStyles() {
      return _.get(this.data, 'customTagStyles', {})
    },
    customStyle() {
      return _.get(this.data, 'style', {})
    }
  },
  created() {
    this.fetchContent()
    this.$set(
      this.htmlComponent, 'customTagStyles', this.customTagStyles
    )
  },
  methods: {
    ...mapActions(['fetchAppPage']),
    async fetchContent() {
      if (this.pageId) {
         try {
           const page = await this.fetchAppPage(this.pageId)
           this.$set(this.htmlComponent, 'html', page.info)
         } catch (error) {
           console.log(error)
         }
      }
    }
  },
}
</script>

<style lang="scss" scoped></style>
